/**
 * LobbyConfig — single visible toggle surface for the /lobby URL.
 *
 * /lobby is the deterministic entry to the live social-hub map
 * (`dj-live-lobby`). Sibling to BrawlConfig / PvEConfig /
 * AbilityTestConfig. The URL exists so DJ + visitors can deep-link
 * to the lobby for stream sessions, social meetups, or trailer
 * shoots without needing to navigate through character select first.
 *
 * Wiring:
 *   - main.tsx          → reads on /lobby path mount; injects URL
 *                         params + reset wipe (mirrors /brawl + /pve
 *                         + /abilitytest)
 *   - DJLiveLobby.ts    → MAP_ID = 'dj-live-lobby'
 *
 * Class default: defaults to mage (the historical quick-pick default), but
 * ClassSwitcherTopBar honors `?class=X` (per the URL-coercion fix
 * 2026-05-02), so DJ can switch on-the-fly without re-navigating
 * through character select.
 */

export const LOBBY_CONFIG = {
  // Cookie/cache hygiene — same as /brawl + /pve + /abilitytest.
  resetOnLoad: true,

  // Class default — what DJ spawns into when no `?class=X` is set.
  defaultClass: 'mage' as const,

  // HUD overrides — match /brawl + /pve. live-lobby preset is the
  // clean social-hub viewport (target-frame on, no dev-only panels).
  preset: 'live-lobby' as const,
  skipSplash: true,
  skipLogin: true,
} as const;
